<div class="blog-post-container container mt-5">

  <!-- نمایش وضعیت بارگذاری -->
  <div *ngIf="isLoading" class="text-center py-5 blog-loading">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">در حال بارگذاری...</span>
    </div>
    <p>در حال بارگذاری جزئیات پست...</p>
  </div>

  <!-- نمایش پیام خطا -->
  <div *ngIf="error" class="alert alert-danger text-center py-3 blog-error" role="alert">
    {{ error }}
  </div>

  <!-- نمایش جزئیات پست -->
  <article *ngIf="post && !isLoading && !error" class="blog-post-card card shadow-lg p-4 mb-5">

    <!-- عنوان پست -->
    <header class="blog-post-header mb-4">
      <h1 class="display-4 fw-bold">{{ post.title }}</h1>
      <!-- نمایش تاریخ یا اطلاعات اضافی اگر موجود بود -->
      <p class="text-muted blog-post-meta">
        منتشر شده در: <span class="fw-medium">{{ post.wich_kind }}</span> <!-- اینجا می‌توانید تاریخ را نمایش دهید اگر در مدل دارید -->
      </p>
    </header>

    <!-- بخش توضیحات -->
    <div class="blog-post-body mb-4">
      <!-- نمایش خلاصه توضیحات -->
      <div *ngIf="!showFullDescription" class="post-summary" [innerHTML]="getShortDescription()"></div>

      <!-- نمایش کامل توضیحات -->
      <div *ngIf="showFullDescription" class="post-full-content" [innerHTML]="post.description"></div>

      <!-- دکمه "ادامه مطلب" یا "نمایش کمتر" -->
      <button *ngIf="needsMoreInfoButton()" (click)="toggleDescription()" class="btn btn-link blog-read-more-btn p-0">
        {{ showFullDescription ? 'نمایش کمتر' : 'ادامه مطلب...' }}
      </button>
    </div>

    <!-- فوتر پست (اختیاری) -->
    <footer class="blog-post-footer mt-4 pt-3 border-top">
      <!-- می‌توانید اطلاعات دیگری مانند نویسنده، برچسب‌ها و ... را اینجا اضافه کنید -->
      <p class="text-end m-0">
        <button class="btn btn-outline-secondary btn-lg" (click)="goBackToList()">
          <i class="bi bi-arrow-left me-2"></i> بازگشت به لیست وبلاگ
        </button>
      </p>
    </footer>

  </article>

  <!-- پیام در صورتی که پستی یافت نشد -->
  <div *ngIf="!post && !isLoading && !error" class="text-center py-5 blog-not-found">
    <p class="lead">متأسفانه، پستی با شناسه مورد نظر یافت نشد.</p>
    <button class="btn btn-primary btn-lg" (click)="goBackToList()">بازگشت به لیست</button>
  </div>

</div>
